module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-Doma-Flood.75c91cd7.gif";